import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface IndexerStatus {
  indexerName: string;
  contractAddress: string;
  status: string;
  isRunning: boolean;
  blocks: {
    current: number;
    initial: number;
    latest: number;
    behind: number;
    total: number;
    progress: number;
  };
  sync: {
    status: string;
    isSynced: boolean;
    blocksBehind: number;
  };
  performance: {
    totalEventsProcessed: number;
    eventsPerHour: number;
    uptimeHours: number;
    lastProcessedBlock: number;
  };
  database: {
    totalEvents: number;
    lastEvent: string | null;
  };
  errors: {
    count: number;
    lastError: string | null;
    hasErrors: boolean;
  };
}

export interface IndexerStatusResponse {
  instance: {
    name: string;
    port: number;
    apiOnly: boolean;
  };
  service: {
    uptime: number;
    startTime: string;
    totalIndexers: number;
    activeIndexers: number;
  };
  blockchain: {
    rpcUrl: string;
    provider: string;
  };
  indexers: IndexerStatus[];
}

@Injectable({
  providedIn: 'root'
})
export class IndexerStatusService {
  private readonly API_URL = 'https://sales-indexer.nfthost.org/indexer/status';

  constructor(private http: HttpClient) {}

  getIndexerStatuses(): Observable<IndexerStatus[]> {
    const regexPattern = environment.indexerStatusRegexp;
    if (!regexPattern) {
      return of([]);
    }

    return this.http.get<IndexerStatusResponse>(this.API_URL).pipe(
      map(response => {
        if (!response || !response.indexers) {
          return [];
        }

        // Filter indexers based on regex pattern
        const regex = new RegExp(regexPattern, 'i');
        return response.indexers.filter(indexer => 
          regex.test(indexer.indexerName)
        );
      }),
      catchError(error => {
        console.error('[IndexerStatusService] Error fetching indexer statuses:', error);
        return of([]);
      })
    );
  }
}

